import React, { useEffect, useMemo, useRef } from 'react';

import { useRecoilValue } from 'recoil';

import Input from 'components/shared/Input/Input';
import Avatar from 'components/shared/Avatar/Avatar';
import { permissions, userState } from 'components/state';
import { current_admin } from 'components/admin/lib/adminState';
import { ADMIN_STATE_STORAGE_KEY } from 'components/admin/lib/storedAdminState';

const CommentInput = ({
  focusOnMount,
  focusInputTrigger,
  onPost,
  loading = false,
  placeholder = 'Reply',
  value,
  disableSend,
  onChange
}) => {
  const inputRef = useRef(null);

  const user = useRecoilValue(userState);
  const adminUser = useRecoilValue(current_admin);
  const permission = useRecoilValue(permissions);

  const persistedAdminUser = useMemo(() => {
    try {
      const localStorageAdmin = localStorage.getItem(ADMIN_STATE_STORAGE_KEY);
      return localStorageAdmin ? JSON.parse(localStorageAdmin) : null;
    } catch {
      return null;
    }
  }, []);
  const adminActor = adminUser?.user_id ? adminUser : persistedAdminUser;
  const adminActorId = adminActor?.user_id;
  const isImpersonating = Boolean(permission?.admin_id);
  const isAdminActorMatched = Number(permission?.admin_id) === Number(adminActorId);
  const actorUser = isImpersonating && isAdminActorMatched ? adminActor : user;

  const handlePost = async () => {
    if (!value?.trim() || loading || disableSend) return;
    await onPost(value);
    onChange?.('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handlePost();
    }
  };

  useEffect(() => {
    if (!focusInputTrigger) return;
    inputRef.current?.focus();
  }, [focusInputTrigger]);

  return (
    <div className="relative">
      <Avatar
        firstName={actorUser?.f_name}
        lastName={actorUser?.l_name}
        id={permission?.admin_id || actorUser?.user_id}
        image={actorUser?.profile_photo}
        className="absolute left-3 top-1/2 z-10 !h-5 !min-h-5 !w-5 !min-w-5 -translate-y-1/2"
      />
      <Input
        forwardedRef={inputRef}
        focusOnMount={focusOnMount}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={loading}
        rightIcon="send-2-mono"
        rightIconColor="primary"
        rightIconClick={handlePost}
        inputClassName="pl-7"
      />
    </div>
  );
};

export default CommentInput;
